const NoProvider = () => null;

export default NoProvider;
